// removed by extract-text-webpack-plugin
module.exports = {"defaultStyle":"Tooltip__defaultStyle___2PHGC","defaultClose":"Tooltip__defaultClose___3C4eQ","defaultTriangle":"Tooltip__defaultTriangle___2yE9C","container":"Tooltip__container___1iGSw","inner":"Tooltip__inner___34nOg","svg":"Tooltip__svg___1D5qj","close":"Tooltip__close___39mNB Tooltip__svg___1D5qj","triangle":"Tooltip__triangle___XBkZH Tooltip__svg___1D5qj","triangleStroke":"Tooltip__triangleStroke___1qO6p","top":"Tooltip__top___3PYiq","left":"Tooltip__left___2ocL0","right":"Tooltip__right___1Jius","shadow":"Tooltip__shadow___GUdZ7","triangleShadow":"Tooltip__triangleShadow___vtHld"};


//////////////////
// WEBPACK FOOTER
// ./styles/Tooltip.css
// module id = 5
// module chunks = 0